'use client'; // Add this line at the top
import React, { useState, useEffect } from 'react';
import AboutOne from '../../components/About/AboutOne';
import TestimonialOne from '../../components/Slider/TestimonialOne';
import BrandTwo from '../../components/Slider/BrandTwo';
import CountUp from 'react-countup'; // Import CountUp from react-countup
import CounterUp from 'react-countup';
import { Link } from 'react-router-dom'; // Assuming you're using react-router for navigation
import WeServeShape1 from '../../assets/images/shapes/we-serve-count-shape-1.png';
import ImageOverlayCardGroup from '../../components/ImageOverlayCardGroup';
import { Helmet } from 'react-helmet';


// Import images
import longArrowImg from '../../assets/images/icon/long-arrow.png';
import serviceImg1 from '../../assets/images/services/services-three-service-list-img-1.jpg';
import serviceImg2 from '../../assets/images/services/services-three-service-list-img-2.jpg';
import serviceImg3 from '../../assets/images/services/services-three-service-list-img-3.jpg';
import serviceImg4 from '../../assets/images/services/services-three-service-list-img-4.jpg';

// Import images
import counterTwoBgShape from '../../assets/images/shapes/counter-two-bg-shape.png';
import counterTwoRightBgShape from '../../assets/images/shapes/counter-two-right-bg-shape.png';
import TestimonialTwo from '../home-2/TestimonialTwo';

const AboutMain = () => {
    const [activeIndex, setActiveIndex] = useState(0);

  const handleOnClick = (index) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    // Hover Image
    const link = document.querySelectorAll(".hover-item");
    const linkHoverReveal = document.querySelectorAll(".hover-item__box");
    const linkImages = document.querySelectorAll(".hover-item__box-img");

    for (let i = 0; i < link.length; i++) {
      link[i].addEventListener("mousemove", (e) => {
        linkHoverReveal[i].style.opacity = 1;
        linkHoverReveal[i].style.transform = `translate(-100%, -50%) rotate(0deg)`;
        linkImages[i].style.transform = "scale(1, 1)";
        linkHoverReveal[i].style.left = e.clientX + "px";
      });
      link[i].addEventListener("mouseleave", () => {
        linkHoverReveal[i].style.opacity = 0;
        linkHoverReveal[i].style.transform = `translate(-50%, -50%) rotate(0deg)`;
        linkImages[i].style.transform = "scale(0.8, 0.8)";
      });
    }
  }, []); // Empty dependency array to run this effect only once after the initial render
    
  
    return (
        <React.Fragment>
            <Helmet>
                <title>About - techtotalers</title>
            </Helmet>
            {/* <AboutOne/> */}
            { /* Counter Two Start */ }
           {<ImageOverlayCardGroup/>} 
            
            { /* Counter Two End */ }
            
            <TestimonialOne />

        </React.Fragment>
    );
};

export default AboutMain;
